import styled from "styled-components";
import React, { useState, useEffect, useContext } from "react";
import Select from "react-select";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import { usePullFightPrediction } from "../../FanPrediction/FanPredictionCall";
import { DataContext } from "../../contexts/DataContext";
import { APIContext } from "../../contexts/APIContext";
import Stat from "../TeamStats/Stat";
import { pullAllFightPredictions } from "../../FanPrediction/FanPredictionCall";
import { pullFightPredictionstatic } from "../../FanPrediction/FanPredictionCall";


const Main = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
`;

const Title = styled.div`
  display: flex;
  border-bottom: 1px solid #dadde1;
  box-sizing: border-box;
  font-size: 1.5em;
  width: 100%;
  padding: 0.5em;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: white;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ActionPanel = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1em;
  /* padding: 1em; */
  align-items: center;
  box-sizing: border-box;
  justify-content: center;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  height: 100%;
`;
const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
`;

const PanelItem = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 22%; 
  min-width: 250px;
  margin-right: 20px;
  margin-bottom: 20px;
  color: white;
`;

const GraphicsPanel = styled.div`
  display: flex;
  flex-direction: row; 
  flex-wrap: wrap;   
  width: 100%;
  padding: 1em;
  box-sizing: border-box;
  background-color: #181d25;
`;

const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#202731"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 5%;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 60px;
  width: 120px;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;

const TitleButton = styled.div`
  display: flex;
  align-items: center;
  background-color: #20273196;
  height: 5%;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 120px;
`;

const PeriodButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#202731"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 5%;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 60px;
  width: 80px;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
const HiddenButton = styled.div`
  display: flex;
  align-items: center;
  opacity: 0;
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 5%;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  height: 60px;
  width: 120px;
`;
const Input = styled.input`
  background-color: #1f222b;
  border-radius: 4px;
  border: none;
  padding: 1em;
  margin-bottom: 1em;
  outline: none;
  color: #fff;
  width: 85%
`;

const Tabs = styled.div`
  display: flex;
`;

const Tab = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: center;
  min-width: 100px;
  margin-right: 4px;
  background-color: ${(props) => (props.selected ? "#db0a41" : "#181d25")};
`;

const SelectContainer = styled(Select)`
  min-width: 200px;
  margin-bottom: 0.5em;
  width: 90%;
`;
const StatDiv = styled.div`
  display: flex;
`;
const Category = styled.div`
  display: flex;
  min-width: 60%;
  justify-content: center;
  padding: 0.5em;
  cursor: pointer;
  background-color: ${(props) => (props.selected ? "#db0a41" : "")};
`;
const Value = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  cursor: pointer;
  padding: 0.5em;
  border-radius: 2px;
  align-items: center;
  font-size: ${(props) => (props.small ? ".8em" : "")};
  :hover {
    background-color: #db0a41;
  }
`;
const Bar = styled.div`
  display: flex;
  width: 100%;
`;
const InnerBar = styled.div`
  display: flex;
`;
const Bars = styled.div`
  display: flex;
  width: 100%;
`;
export default function BottomPanel({game,})
{
  const [guest1, setGuest1] = useLocalStorage("combat-guest-1", "");
  const [guest2, setGuest2] = useLocalStorage("combat-guest-2", "");
  const [guest3, setGuest3] = useLocalStorage("combat-guest-3", "");
  const [guest4, setGuest4] = useLocalStorage("combat-guest-4", "");
  const [analysis1, setAnalysis1] = useLocalStorage("combat-analysis-1", "");
  const [analysis2, setAnalysis2] = useLocalStorage("combat-analysis-2", "");
  const [analysis3, setAnalysis3] = useLocalStorage("combat-analysis-3", "");
  const [analysis4, setAnalysis4] = useLocalStorage("combat-analysis-4", "");
  const initialRounds = Array.from({ length: 12 }, () => ({ score: ""}));
  const [scorecard, setScorecard] = useLocalStorage("combat-scorecard-local", [
    {
      viewer: "Name",
      rounds: initialRounds,
      deductions: 0
    },
    {
      viewer: "Name B",
      rounds: initialRounds,
      deductions: 0
    },
  ])
  const updateScore = (viewerIndex, roundIndex, newValue) => {
    setScorecard(prev => {
      const newScorecard = [...prev];
      const updatedViewer = { ...newScorecard[viewerIndex]};
      const updatedRounds = [...updatedViewer.rounds];
      updatedRounds[roundIndex] = { ...updatedRounds[roundIndex], score: newValue };
      updatedViewer.rounds = updatedRounds
      newScorecard[viewerIndex] = updatedViewer;
      return newScorecard;
    });
  };
  const updateDeduction = (viewerIndex, value) => {
    const newScorecard = [...scorecard]
    newScorecard[viewerIndex].deductions = value;
    setScorecard(newScorecard)
  }
  const updateViewer = (viewerIndex, value) => {
    const newScorecard = [...scorecard]
    newScorecard[viewerIndex].viewer = value;
    setScorecard(newScorecard)
  }
  const pullFightPrediction = usePullFightPrediction();
  const [view, setView] = useState(0);
  const [selectedGraphic, setSelectedGraphic] = useState();
  const [commentators, setCommentators] = useState([]);
  useEffect(() => {
    if (game?.commentators) {
      setCommentators(game?.commentators);
    }
  }, [game]);
  const [localMc, setLocalMc] = useState({});
  useEffect(() => {
    if (game?.mc) {
      setLocalMc(game?.mc);
    }
   }, [game]);
  
  const [localprediction, setLocalprediction] = useLocalStorage("game_prediciton")
  const {
    previewGraphic,
    animateGraphic,
    graphicInPreview,
    animateOffGraphic,
    updateGraphic,
    clearPVW,
  } = useContext(GraphicsContext);
  const {updateWinner, updatePrediction, updateComms} = useContext(APIContext);
  const [customIndex, setCustomIndex] = useState("");
  const [allPredictions, setAllPredictions] = useLocalStorage("all_predictions")
  let period = [...(game?.live_data?.periods || [])].sort(
    (a, b) => b.number - a.number
  )[0];

return (
<Main
style={{justifyContent: "flex-end"}}>

  <Tabs>
    <Tab
    selected={view === 0}
    onClick={() => {
    setView(0);
    }}
    >
      Hide
    </Tab>
    <Tab
    selected={view === 1}
    onClick={() => {
    setView(1);
    }}
    >
    Lower Thirds
    </Tab>
    {game?.competition?.competition_type === "Total Kombat" &&
    <Tab
    selected={view === 2}
    onClick={async () => {
      setView(2);
      let predictions = await pullFightPrediction(game);
      setLocalprediction(predictions)
        updatePrediction({...game, id: game._id, prediction_data: predictions})
    }}
    >
    Fight Prediction
    </Tab>
    }
    {game?.competition?.competition_type === "Sky Boxing" &&
    <Tab
    selected={view === 2}
    onClick={() => {
      setView(2);
    }}
    >
    Viewer Scorecard
    </Tab>
    }
    {game?.competition?.competition_type === "Sky Boxing" &&
    <Tab
    selected={view === 3}
    onClick={() => {
      setView(3);
    }}
    >
    Analysis Tags
    </Tab>
    }
  </Tabs>
  {view === 0 && (<GraphicsPanel style={{height: "0%"}}></GraphicsPanel>)}
 {view === 1 && (
  <GraphicsPanel>
    {commentators?.map((comm, index) => (
      <PanelItem key={comm._id || index}>
        Commentator {index + 1}
        <Input
          value={comm?.first_name || ""}
          placeholder="First name"
          onChange={(e) => {
            let newComms = [...commentators];
            newComms[index] = { ...comm, first_name: e.target.value };
            setCommentators(newComms);
          }}
        />
        <Input
          value={comm?.last_name || ""}
          placeholder="Last name"
          onChange={(e) => {
            let newComms = [...commentators];
            newComms[index] = { ...comm, last_name: e.target.value };
            setCommentators(newComms);
          }}
        />
        <Input
          value={comm?.subline || ""}
          placeholder="Subline"
          onChange={(e) => {
            let newComms = [...commentators];
            newComms[index] = { ...comm, subline: e.target.value };
            setCommentators(newComms);
          }}
        />
        <Row>
          <GraphicButton onClick={() => updateComms({id: game._id, commentators: commentators })}>
            Save Com to DB
          </GraphicButton>
          <GraphicButton onClick={() => {
            setSelectedGraphic(index);
            previewGraphic("Guest", { game: game, first_name: comm?.first_name, last_name: comm?.last_name, subline: comm?.subline});
          }}>
            Lower Third {index + 1}
          </GraphicButton>
          {selectedGraphic === index && (
            <>
              <GraphicButton green onClick={() => animateGraphic("Guest")}>In</GraphicButton>
              <GraphicButton red onClick={() => { setSelectedGraphic(); animateOffGraphic("Guest"); }}>Out</GraphicButton>
            </>
          )}
        </Row>
      </PanelItem>
    ))}
    <PanelItem>
      MC
      <Input
        value={localMc?.first_name || ""}
        placeholder="First name"
        onChange={(e) => {
          let new_mc = { ...localMc, first_name: e.currentTarget.value };
          setLocalMc(new_mc);
        }}
      />
      <Input value={localMc?.last_name || ""} placeholder="Last name" onChange={(e) => {
          let new_mc = { ...localMc, last_name: e.currentTarget.value };
          setLocalMc(new_mc);
      }} />
      <Input value={localMc?.subline || ""} placeholder="Subline" onChange={(e) => {
          let new_mc = { ...localMc, subline: e.currentTarget.value };
          setLocalMc(new_mc);
      }} />
      <Row>
          <GraphicButton onClick={() => updateComms({id: game._id, mc: localMc })}>
            Save MC to DB
          </GraphicButton>
        <GraphicButton onClick={() => {
          setSelectedGraphic("mc");
          previewGraphic("Guest", { game: game, first_name: localMc?.first_name, last_name: localMc?.last_name, subline: localMc?.subline});
        }}>MC Lower Third</GraphicButton>
        {selectedGraphic === "mc" && (
          <>
            <GraphicButton green onClick={() => animateGraphic("Guest")}>In</GraphicButton>
            <GraphicButton red onClick={() => { setSelectedGraphic(); animateOffGraphic("Guest"); }}>Out</GraphicButton>
          </>
        )}
      </Row>
    </PanelItem>
    <div style={{ width: "100%", display: "flex", flexWrap: "wrap", marginTop: "5px", paddingTop: "10px" }}>
      <GuestGFX
        game={game}
        guest={guest1}
        setGuest={setGuest1}
        previewGraphic={previewGraphic}
        selectedGraphic={selectedGraphic}
        animateGraphic={animateGraphic}
        animateOffGraphic={animateOffGraphic}
        setSelectedGraphic={setSelectedGraphic}
        label="Guest 1"
      />
      <GuestGFX
        game={game}
        guest={guest2}
        setGuest={setGuest2}
        previewGraphic={previewGraphic}
        selectedGraphic={selectedGraphic}
        animateGraphic={animateGraphic}
        animateOffGraphic={animateOffGraphic}
        setSelectedGraphic={setSelectedGraphic}
        label="Guest 2"
      />
      <GuestGFX
        game={game}
        guest={guest3}
        setGuest={setGuest3}
        previewGraphic={previewGraphic}
        selectedGraphic={selectedGraphic}
        animateGraphic={animateGraphic}
        animateOffGraphic={animateOffGraphic}
        setSelectedGraphic={setSelectedGraphic}
        label="Guest 3"
      />
      <GuestGFX
        game={game}
        guest={guest4}
        setGuest={setGuest4}
        previewGraphic={previewGraphic}
        selectedGraphic={selectedGraphic}
        animateGraphic={animateGraphic}
        animateOffGraphic={animateOffGraphic}
        setSelectedGraphic={setSelectedGraphic}
        label="Guest 4"
      />
    </div>
  </GraphicsPanel>
)}
  {(view === 2 && game?.competition?.competition_type === "Total Kombat") && (<GraphicsPanel style={{placeContent: "center",}}>
    <Main style={{width: "80%", padding: "0.5em", }}>
      <Column style={{alignItems: "center"}}>
      Fight Prediction
      </Column>
      <Column style={{alignItems: "center", marginTop: "15px"}}>
      {game?.prediction_data?.big_text}
      </Column>
    <div>
   <StatDiv>
    <Value>
      {game?.prediction_data?.engagement?.total?.votes_a} / {game?.prediction_data?.engagement?.total?.total_votes}
      <Category  style={{ justifyContent: "flex-end" }}>
    {game?.prediction_data?.choice_a}</Category>
    </Value>
    <Value>
      <Category style={{ justifyContent: "flex-start" }}>
    {game?.prediction_data?.choice_b}</Category>
    {game?.prediction_data?.engagement?.total?.votes_b} / {game?.prediction_data?.engagement?.total?.total_votes}
    </Value>
   </StatDiv>
         <Bars>
        <Bar style={{ justifyContent: "flex-end" }}>
          <InnerBar 
          style={{
            width: game?.prediction_data?.engagement?.total?.percentage_a + "%",
            height: "2px",
            backgroundColor: "rgba(38, 0, 255, 1)",
          }}/>
        </Bar>
        <Bar>
          <InnerBar
              style={{
            width: game?.prediction_data?.engagement?.total?.percentage_b + "%",
            height: "2px",
            backgroundColor: "rgba(255, 0, 0, 1)",
          }}/>
        </Bar>
      </Bars>
      </div>
      <Row style={{justifyContent: "center"}}>
      <GraphicButton
      style={{alignSelf: "center"}}
             onClick={async () => { 
        let predictions = await pullFightPrediction(game);
        console.log(predictions)
        setLocalprediction(predictions)
        updatePrediction({...game, id: game._id, prediction_data: predictions})
        }}
      >
        Pull Data</GraphicButton>
        <Input style = {{width: "100px"}} value={customIndex} placeholder="Custom Fight" onChange={(e) => setCustomIndex(e.target.value)}></Input>
          <GraphicButton
      style={{alignSelf: "center",}}
             onClick={async () => { 
        let predictions = await pullFightPredictionstatic(customIndex);
        console.log(predictions)
        setLocalprediction(predictions)
        updatePrediction({...game, id: game._id, prediction_data: predictions})
        }}
      >
        Pull Custom Fight Data</GraphicButton>
        </Row>
      <GraphicButton
      style={{alignSelf: "center"}}
             onClick={async () => { 
        let newPredictions = await pullAllFightPredictions();
        console.log(newPredictions)
        setAllPredictions(newPredictions)
        }}
      >
        Pull All Fights</GraphicButton>
      <Column style={{alignItems: "center", marginTop: "15px"}}>
      {allPredictions?.questions?.map((que, index) => {return(
      <span key={index}>{que?.big_text} - Total Votes:  {que?.total_votes}</span>
    )})}
      </Column>
    </Main>
  </GraphicsPanel>)}
  {(view === 2 && game?.competition?.competition_type === "Sky Boxing") && (<GraphicsPanel style={{placeContent: "center", height:"80%"}}>
    <Main style={{width: "80%", padding: "0.5em", }}>
      <Column style={{alignItems: "center"}}>
      Viewer Scorecard - Round {period.number}
      <Row>
        <Column style={{marginLeft: "5px", width: "125px"}}> 
          <span>{game?.home_fighter.first_name} {game?.home_fighter.last_name}</span>
         </Column>
        {[...Array(game?.number_of_rounds || 12)].map((_, i) => (
          
        <Column key={i} style={{marginLeft: "5px", alignItems: "center",
          opacity: (i < period.number ) ?
          "100%" :
          "50%",
        }}>  
        <span style={{marginLeft: "5px",
          borderBottom: ( i+1 === period.number ) ?
        "2px solid #0adb93" 
        : "none",
        }}>R{i+1}</span>
        <Input 
        type="number"
        value={scorecard[0]?.rounds[i]?.score || ""}
        onChange={(e) => updateScore(0, i, e.target.value)}
        style={{width: "50px"}}
        />
        </Column>
      ))}
      <Column style={{marginLeft: "5px", alignItems: "center"}}>  
        <span>PD</span>
        <Input style = {{width: "50px"}} 
         value={scorecard[0]?.deductions} 
         placeholder="Points Deductions" 
         onChange={(e) => updateDeduction(0, e.target.value)}></Input>
         </Column>
        </Row>
      <Row>
        <Column style={{marginLeft: "5px", width: "125px"}}> 
        <span>{game?.away_fighter.first_name} {game?.away_fighter.last_name}</span>
        </Column>
        {[...Array(game?.number_of_rounds || 12)].map((_, i) => (
        <Row key={i} style={{marginLeft: "5px",
          opacity: (i < period.number ) ?
          "100%" :
          "50%",
        }}>
        <Input 
        type="number"
        value={scorecard[1]?.rounds[i]?.score || ""}
        onChange={(e) => updateScore(1, i, e.target.value)}
        style={{width: "50px"}}
        />
        </Row>
      ))}
        <Input style = {{width: "50px", marginLeft: "5px"}} 
         value={scorecard[1]?.deductions} 
         placeholder="Points Deductions" 
         onChange={(e) => updateDeduction(1, e.target.value)}></Input>
        </Row>
        <Row>
          <GraphicButton 
          style={{width: "200px"}}
          onClick={() => {
            setSelectedGraphic("scorecard");
            previewGraphic("scorecard", { game: game, scorecard: scorecard, period: period});
          }}>
           Preview Scorecard
          </GraphicButton>
          {selectedGraphic === "scorecard" && (
            <>
              <GraphicButton style={{width: "200px"}} green onClick={() => animateGraphic("scorecard")}>Scorecard In</GraphicButton>
              <GraphicButton style={{width: "200px"}} red onClick={() => { setSelectedGraphic(); animateOffGraphic("scorecard"); }}>Scorecard Out</GraphicButton>
            </>
          )}
        </Row>
      </Column>

    </Main>
  </GraphicsPanel>)}
  {(view === 3 && game?.competition?.competition_type === "Sky Boxing") && (<GraphicsPanel style={{placeContent: "center", height:"80%"}}>
    <Main style={{width: "80%", padding: "0.5em", }}>
      <Column style={{alignItems: "center"}}>
      Analysis Tags
      <Row>
        {[...Array(game?.number_of_rounds || 12)].map((_, i) => (
          
          <GraphicButton 
          key={i}
          style={{width: "105px"}}
          onClick={() => {
            let roundno = "Round " + (i+1);
            setSelectedGraphic(roundno);
            previewGraphic("Bug" , {
              content: roundno
            });
          }}>
           Round {i+1} Bug
          </GraphicButton>
      ))}
          </Row>
          <Row>
          <AnalysisGFX
                game={game}
                analysis={analysis1}
                setAnalysis={setAnalysis1}
                previewGraphic={previewGraphic}
                selectedGraphic={selectedGraphic}
                animateGraphic={animateGraphic}
                animateOffGraphic={animateOffGraphic}
                setSelectedGraphic={setSelectedGraphic}
                label="Tag 1"
              />
              <AnalysisGFX
                game={game}
                analysis={analysis2}
                setAnalysis={setAnalysis2}
                previewGraphic={previewGraphic}
                selectedGraphic={selectedGraphic}
                animateGraphic={animateGraphic}
                animateOffGraphic={animateOffGraphic}
                setSelectedGraphic={setSelectedGraphic}
                label="Tag 2"
              />
              <AnalysisGFX
                game={game}
                analysis={analysis3}
                setAnalysis={setAnalysis3}
                previewGraphic={previewGraphic}
                selectedGraphic={selectedGraphic}
                animateGraphic={animateGraphic}
                animateOffGraphic={animateOffGraphic}
                setSelectedGraphic={setSelectedGraphic}
                label="Tag 3"
              />
              <AnalysisGFX
                game={game}
                analysis={analysis4}
                setAnalysis={setAnalysis4}
                previewGraphic={previewGraphic}
                selectedGraphic={selectedGraphic}
                animateGraphic={animateGraphic}
                animateOffGraphic={animateOffGraphic}
                setSelectedGraphic={setSelectedGraphic}
                label="Tag 4"
              />
        </Row>
        <Row>
        {(selectedGraphic?.startsWith("Round") || selectedGraphic?.startsWith("Tag")) && (
            <>
              <GraphicButton style={{width: "200px"}} green onClick={() => animateGraphic("Bug")}>{selectedGraphic} In</GraphicButton>
              <GraphicButton style={{width: "200px"}} red onClick={() => { setSelectedGraphic(); animateOffGraphic("Bug"); }}>{selectedGraphic} Out</GraphicButton>
            </>
          )}
        </Row>
      </Column>

    </Main>
  </GraphicsPanel>)}

</Main>
)
}


function GuestGFX({
  game,
  guest,
  setGuest,
  previewGraphic,
  selectedGraphic,
  animateGraphic,
  animateOffGraphic,
  setSelectedGraphic,
  label,
  label2,
}) {
  return (
    <PanelItem>
      <Input
        value={guest?.first_name}
        placeholder="Guest First Name"
        onChange={(e) => {
          let new_guest_1 = { ...guest };
          new_guest_1.first_name = e.currentTarget.value;
          setGuest(new_guest_1);
        }}
      />
      <Input
        value={guest?.last_name}
        placeholder="Guest Last Name"
        onChange={(e) => {
          let new_guest_1 = { ...guest };
          new_guest_1.last_name = e.currentTarget.value;
          setGuest(new_guest_1);
        }}
      />
      
      <Input
        value={guest?.subline}
        placeholder="Guest Subline"
        onChange={(e) => {
          let new_guest_1 = { ...guest };
          new_guest_1.subline = e.currentTarget.value;
          setGuest(new_guest_1);
        }}
      />
      <Row
      style={{alignItems: "flex-start"}}>
      <GraphicButton
        onClick={() => {
          setSelectedGraphic(label);
          previewGraphic("Guest", {
            game: game,
            first_name: guest?.first_name,
            last_name: guest?.last_name,
            subline: guest?.subline,
          });
        }}
      >
        {label}
      </GraphicButton>
      {selectedGraphic === label && (
        <>
          <GraphicButton
            green
            onClick={() => {
              animateGraphic("Guest");
            }}
          >
            In
          </GraphicButton>
          <GraphicButton
            red
            onClick={() => {
              setSelectedGraphic();
              animateOffGraphic("Guest");
            }}
          >
            Out
          </GraphicButton>
        </>
      )}
      </Row>
    </PanelItem>
  );
}

function AnalysisGFX({
  game,
  analysis,
  setAnalysis,
  previewGraphic,
  selectedGraphic,
  animateGraphic,
  animateOffGraphic,
  setSelectedGraphic,
  label,
}) {
  return (
    <Column style={{ marginRight: "30px",}}>
      <span style={{ marginLeft: "1em"}}>
      Analysis Tag
      </span>
      <Row
      style={{justifyContent: "center"}}>
      <Input
      style={{margin: "0.5em"}}
        value={analysis?.name}
        onChange={(e) => {
          let new_analysis_1 = { ...analysis };
          new_analysis_1.name = e.currentTarget.value;
          setAnalysis(new_analysis_1);
        }}
      />
      <GraphicButton
      style={{ height: "40px", margin: "0.5em"}}
        onClick={() => {
          setSelectedGraphic(label);
          previewGraphic("Bug", {
            game: game,
            content: analysis?.name,
          });
        }}
      >
        {label}
      </GraphicButton>
      </Row>
    </Column>
  );
}
